import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';

import { PageOneColumn, PageWithSidebar } from '../../components/Layouts';
import { SidebarDiscussionsSkeleton } from '../../components/SidebarDiscussions';
import { PageHeaderContainer } from '../PageHeader';
import { PostPreviewContainer } from '../PostPreview';
import { PostCardBodyLayout } from '../../components/PostCardBodyLayout';
import { SidebarNewsSkeleton } from '../../components/SidebarNews';
import { PostParentsSkeleton } from '../../components/PostParents';
import { NothingFound } from '../../components/NotFound';
import { selectPostPreview } from '../../selectors/postPreview';
import { useEffectOnce } from '../../utils';
import { resetPostPreview } from '../../actions/postPreview';
import { ERequestStatus } from '../../types/requestStatus';
import { TThunkDispatch } from '../../types/redux';

/**
 * Контейнер карточки превью поста
 */
export const PostPreviewCardContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const deviceType = useDeviceType();
  // TODO: пока нет механизма определения типа шаблона
  const layoutType: 'with-sidebar' | 'oneColumn' = 'with-sidebar';
  const Layout: typeof PageOneColumn | typeof PageWithSidebar =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    layoutType === 'oneColumn' ? PageOneColumn : PageWithSidebar;
  const postPreview = useSelector(selectPostPreview);

  useEffectOnce(() => {
    return () => {
      dispatch(resetPostPreview());
    };
  });

  if (postPreview.status !== ERequestStatus.Succeed) {
    return <NothingFound />;
  }

  return (
    <Layout
      header={<PageHeaderContainer />}
      body={
        <PostCardBodyLayout>
          <PostParentsSkeleton />
          <PostPreviewContainer />
        </PostCardBodyLayout>
      }
    >
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*// @ts-ignore*/}
      {layoutType === 'with-sidebar' && deviceType === 'desktop' && (
        <>
          <SidebarDiscussionsSkeleton />
          <SidebarNewsSkeleton />
        </>
      )}
    </Layout>
  );
};
